import { IExtremeGridState } from '../entities';
import { IBaseMutableAction } from '@bimser/core';

export default function changeHiddenColumnReducer(
	state: IExtremeGridState,
	action: IBaseMutableAction<Array<string>>
): IExtremeGridState {
	return {
		...state,
		columns: state.columns.map(item => ({
			...item,
			visible: !action.payload.some(c => c == item.name)
		}))
	};
}
